import React, { useContext, useEffect } from "react";
import { Context as PointsContext } from "../../context/PointsContext";
import SortingTable from "../../components/SortingTable";
import PointIndicators from "./PointIndicators";

const headCells = [
  {
    id: "user",
    numeric: false,
    disablePadding: false,
    label: "Usuario",
  },
  {
    id: "reward",
    numeric: false,
    disablePadding: true,
    label: "Recompensa",
  },
  { id: "pointsClaimed", numeric: true, disablePadding: false, label: "Puntos Canjeados" },
  { id: "pointsRemaining", numeric: true, disablePadding: false, label: "Puntos Restantes" },
  {
    id: "date",
    numeric: false,
    disablePadding: false,
    label: "Fecha y Hora",
  },
];

const Points = ({history}) => {
  const {
    state: { claims },
    fetchClaims
  } = useContext(PointsContext);


  useEffect(() => {
    fetchClaims();
    // eslint-disable-next-line
  }, []);

  const rows = claims.map((claim) => {
    return {
      user: claim.email,
      reward: claim.reward.name,
      pointsClaimed: claim.reward.points,
      pointsRemaining: claim.currentPoints,
      date: claim.timestamp,
    };
  });


  return (
    <div>
      <PointIndicators/>
      <SortingTable headCells={headCells} rows={rows} title="Canjes" handleRowClick={()=>{}} />
    </div>
  );
};
export default Points;
